module.exports = __webpack_public_path__ + "static/img/al-bg.a536c8b2.png";